// Import main styles
import '../css/app.css';

// Import components
import './components/header';

// Import modules
import './modules/search-overlay';
import { initScrollAnimations } from './modules/scroll-animations';
import { initNewsCardExcerpts } from './modules/news-card-excerpt';
import { initInfiniteScroll } from './modules/infinite-scroll';

// Remove no-js class if JavaScript is enabled
document.documentElement.classList.remove('no-js');

// Initialize modules
document.addEventListener('DOMContentLoaded', () => {
  initScrollAnimations();
  
  // Initialize news card excerpts if elements exist
  if (document.querySelector('.news-card-excerpt')) {
    initNewsCardExcerpts();
  }
  
  // Initialize infinite scroll if on blog/archive pages
  if (document.querySelector('#infinite-scroll-data')) {
    initInfiniteScroll();
  }
});